import { render, staticRenderFns } from "./SopDocumentHistory.vue?vue&type=template&id=0014cbba&scoped=true&"
import script from "./SopDocumentHistory.vue?vue&type=script&lang=ts&"
export * from "./SopDocumentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SopDocumentHistory.vue?vue&type=style&index=0&id=0014cbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0014cbba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VDataTable})
